








































































































































































































































// tslint:disable
import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import {
  ContentToolbarExpandFilterBlock,
  SwContentToolbar,
  SwContentToolbarExpand,
} from '@sonicwall/unified-ui-framework/src/shared/sw-content-toolbar';
import { CreateElement, VNode } from 'vue';
import {
  SwTextfield,
  SwExpandableTextfield,
} from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import {
  SwTable,
  ColumnSortRequestData,
  SortedColumnInfo,
  TableColumnConfig,
  TableEntry,
  TableEntryFloatAction,
} from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { SelectOption, SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { SwIconButton } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-button';
import { SwButton } from '@libs-uuif/shared/sw-button';
import { SwDatetimePicker, DateTimePickerConfig } from '@sonicwall/unified-ui-framework/src/shared/sw-datetime-picker';
import AddNewUser from '../../msw-profile/components/add-new-user.vue';
import _ from 'lodash';
import {
  ConfirmButton,
  ConfirmOptions,
  confirmService,
} from '@sonicwall/unified-ui-framework/src/shared/confirm-service';
import { SwModal, SwModalBody, SwModalFooter } from '@libs-uuif/shared/sw-modal';
import { SwTextarea } from '@libs-uuif/shared/sw-textfield';
import { InfoState } from '@/core';
import DeleteUser from './deleteUser/delete-user.vue';
import { TooltipDirValues } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir';
import { envCongif } from '@/shared/env.config';
import SuperAdminModal from '@/shared/addOrUpdateSuperAdminModal/addOrUpdateSuperAdminModal.vue';

const cssPrefix = 'org-user-list';

@Component({
  components: {
    SwTable,
    SwContentToolbar,
    SwIconButton,
    SwIcon,
    SwExpandableTextfield,
    SwContentToolbarExpand,
    AddNewUser,
    SwTextarea,
    SwTextfield,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
    SwDatetimePicker,
    DeleteUser,
    SuperAdminModal,
  },
})
export default class OrgUserlist extends SwExtendedVue {
  cssPrefix = cssPrefix;

  statusFilter: string = '';
  nameFilter: string = '';
  emailFilter: string = '';
  userGroupFilter: string = '';
  filterColumnKey: string = '';
  filterColumnValue: string = '';
  searchInputText: string = '';
  filterApplied: boolean = false;
  expandVisible: boolean = false;
  showGenerateAPIKeyIcon: boolean = false;
  showViewAPIKeyIcon: boolean = false;
  isExpandSearchFilter: boolean = false;
  openApiKeyDetails: boolean = false;
  showGeneratedKey: boolean = false;
  showDetails: boolean = false;
  showGrant: boolean = false;
  showDelete: boolean = false;
  showRevoke: boolean = false;
  dataToDisplay: any = {};
  generatedMsg: string = '';
  userDetails: any = {};
  generatedApiKey: string = '';
  userGrpToDisplay: any = '';
  showHyperLink: boolean = false;
  showAPIkey: boolean = false;
  apiKey: any = {
    userType: 'Employee',
    userEmail: '',
    desc: '',
    ip: '',
    expDate: '',
  };
  singlePickerConfig: DateTimePickerConfig = {
    placeholder: 'Pick a Date',
    dateFormat: 'DD/MM/YYYY',
    selectableDatesRange: { startDate: this.getStartDate(), endDate: this.getEndDate() },
    hidePreAndNextMonthDates: true,
  };
  filterBlockGrid: ContentToolbarExpandFilterBlock[][] = [];
  sortedColumns: SortedColumnInfo[] = [{ ascending: true, colKey: 'fullName' }];

  userListData: TableEntry[] = [];
  filteredUserList: TableEntry[] = [];

  flexspendAccessList: any[] = [];
  userMgmtPermissionList: any[] = [];

  showFlexspendAccessColumn: boolean = false;
  showMswTypePermissionColumn: boolean = false;
  showDeleteUserIcon: boolean = false;
  showFlexSpend: boolean = false;

  options: ConfirmOptions;
  buttons: ConfirmButton[];
  confirmService: any = confirmService;

  displayAddNewUser: boolean = false;
  orgBasedsuperAdminButtonText: string = '';
  showOrgBasedIcon: string = '';
  addOrUpdateSuperAdminModal: boolean = false;

  get getUserMgmtPermissionOptions(): SelectOption[] {
    return this.userMgmtPermissionList;
  }

  get getFlexspendAccessOptions(): SelectOption[] {
    return this.flexspendAccessList;
  }

  get getTableHeight() {
    let remainsTableHeight = 300;
    if (this.expandVisible) {
      remainsTableHeight = 500;
    }
    return remainsTableHeight;
  }

  get getTitle() {
    // tslint:disable-next-line
    if (this.showDetails) return String(this.$t('accessMgmt.api'));
    else return String(this.$t('accessMgmt.genApi'));
  }

  get getWidth() {
    const width: any = '58rem';
    return width;
  }

  get getGeneratedKey() {
    if (this.showAPIkey) return this.generatedApiKey;
    else {
      const key = this.generatedApiKey.substr(this.generatedApiKey.length - 4);
      return key;
    }
  }

  get getUserListData() {
    return this.userListData;
  }

  onToggleFilterExpand() {
    this.expandVisible = !this.expandVisible;
  }

  onRequestSorting(data: ColumnSortRequestData) {
    data.cancel = false;
    const index = this.sortedColumns.findIndex((col) => col.colKey === data.colKey);
    if (index < 0) {
      if (data.cancel) {
        return;
      }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.ascending === undefined) {
        this.sortedColumns[index].ascending = !this.sortedColumns[index].ascending;
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }

  handleSearchFilter() {
    if (this.searchInputText.trim() === '') {
      this.filterApplied = false;
      return;
    }
    this.filteredUserList = _.filter(this.userListData, (o: any) => {
      let flag = false;
      if (
        o.logon.toLowerCase().indexOf(this.searchInputText.toLowerCase()) > -1 ||
        o.fullName.toLowerCase().indexOf(this.searchInputText.toLowerCase()) > -1 ||
        o.emailAddress.toLowerCase().indexOf(this.searchInputText.toLowerCase()) > -1 ||
        o.associatedUserGroups.toLowerCase().indexOf(this.searchInputText.toLowerCase()) > -1
      ) {
        flag = true;
      }
      if (flag) {
        return o;
      }
    }) as TableEntry[];
    this.filterApplied = true;
  }

  mutateFilterState(name: any, event: any) {
    switch (name) {
      case 'status':
        this.statusFilter = event;
        break;
      case 'name':
        this.nameFilter = event;
        break;
      case 'email':
        this.emailFilter = event;
        break;
      case 'userGroup':
        this.userGroupFilter = event;
        break;
      case 'searchInputText':
        this.searchInputText = event;
        break;
    }
    if (
      !this.statusFilter &&
      !this.nameFilter &&
      !this.emailFilter &&
      !this.userGroupFilter &&
      !this.searchInputText
    ) {
      this.filterApplied = false;
    }
  }

  applyFilters() {
    this.filteredUserList = _.filter(this.userListData, (o: any) => {
      let flag = true;
      if (
        this.statusFilter !== '' &&
        o.logon.toLowerCase().indexOf(this.statusFilter.toLowerCase()) === -1
      ) {
        flag = false;
      }
      if (
        this.nameFilter !== '' &&
        o.fullName.toLowerCase().indexOf(this.nameFilter.toLowerCase()) === -1
      ) {
        flag = false;
      }
      if (
        this.emailFilter !== '' &&
        o.emailAddress.toLowerCase().indexOf(this.emailFilter.toLowerCase()) === -1
      ) {
        flag = false;
      }
      if (
        this.userGroupFilter !== '' &&
        o.associatedUserGroups.toLowerCase().indexOf(this.userGroupFilter.toLowerCase()) === -1
      ) {
        flag = false;
      }
      if (flag) {
        return o;
      }
    }) as TableEntry[];
    this.filterApplied = true;
  }

  private viewStatusRender(h: CreateElement): VNode {
    // tslint:disable-line
    return (
      <div>
        <SwTextfield
          {...{
            props: {
              name: 'status',
              value: this.statusFilter,
              placeholder: this.$t('orderHistory.status')
              .toString(),
            },
            style: {
              width: '200px',
            },
            on: {
              keyup: (event: any) => {
                if (event.keyCode === 13) {
                  this.applyFilters();
                }
              },
              input: (event: any) => {
                this.mutateFilterState('status', event);
              },
            },
          }}
        ></SwTextfield>
      </div>
    ) as VNode;
  }
  private viewNameRender(h: CreateElement): VNode {
    // tslint:disable-line
    return (
      <div>
        <SwTextfield
          {...{
            props: {
              name: 'name',
              value: this.nameFilter,
              placeholder: this.$t('products.name')
              .toString(),
            },
            style: {
              width: '200px',
            },
            on: {
              keyup: (event: any) => {
                if (event.keyCode === 13) {
                  this.applyFilters();
                }
              },
              input: (event: any) => {
                this.mutateFilterState('name', event);
              },
            },
          }}
        ></SwTextfield>
      </div>
    ) as VNode;
  }
  private viewEmailRender(h: CreateElement): VNode {
    // tslint:disable-line
    return (
      <div>
        <SwTextfield
          {...{
            props: {
              name: 'email',
              value: this.emailFilter,
              placeholder: this.$t('profile.email')
              .toString(),
            },
            style: {
              width: '200px',
            },
            on: {
              keyup: (event: any) => {
                if (event.keyCode === 13) {
                  this.applyFilters();
                }
              },
              input: (event: any) => {
                this.mutateFilterState('email', event);
              },
            },
          }}
        ></SwTextfield>
      </div>
    ) as VNode;
  }
  private viewUserGroupRender(h: CreateElement): VNode {
    // tslint:disable-line
    return (
      <div>
        <SwTextfield
          {...{
            props: {
              name: 'userGroup',
              value: this.userGroupFilter,
              placeholder: this.$t('groups.editUGroupName')
              .toString(),
            },
            style: {
              width: '200px',
            },
            on: {
              keyup: (event: any) => {
                if (event.keyCode === 13) {
                  this.applyFilters();
                }
              },
              input: (event: any) => {
                this.mutateFilterState('userGroup', event);
              },
            },
          }}
        ></SwTextfield>
      </div>
    ) as VNode;
  }

  loadFilterData() {
    const tableHeader = document.querySelector('.msw-table-toolbar') as HTMLElement;
    let totalWidth = 0;
    if (tableHeader) {
      totalWidth = tableHeader.getBoundingClientRect().width;
    }
    this.filterBlockGrid = [
      [
        {
          title: this.$t('orderHistory.status')
          .toString(),
          content: this.viewStatusRender,
          width: totalWidth / 4 || 200,
        },
        {
          title: this.$t('products.name')
          .toString(),
          content: this.viewNameRender,
          width: totalWidth / 4 || 200,
        },
        {
          title: this.$t('profile.email')
          .toString(),
          content: this.viewEmailRender,
          width: totalWidth / 4 || 200,
        },
        {
          title: this.$t('groups.editUGroupName')
          .toString(),
          content: this.viewUserGroupRender,
          width: totalWidth / 4 || 200,
        },
      ],
    ];
  }

  get getUserGrpName() {
    let formatedUserGrpName = '';
    if (this.userGrpToDisplay && this.userGrpToDisplay.length > 34) formatedUserGrpName = `${this.userGrpToDisplay.slice(0, 34)}....`;
    else formatedUserGrpName = this.userGrpToDisplay;
    return formatedUserGrpName;
  }

  getUserList() {
    this.userListData = [];
    this.$store.commit('startLoading');
    return new Promise((resolve: any) => {
      this.$store.dispatch('SnbProfileStoreModule/getUserList', 'NO').then((resp) => {
        this.userGrpToDisplay = resp.content?.userGroupNames;
        if (resp.operationStatus === 'OK') {
          this.showGenerateAPIKeyIcon = resp?.content?.showGenerateAPIKeyIcon;
          this.showViewAPIKeyIcon = resp?.content?.showViewAPIKeyIcon;
        }
        if (resp.operationStatus === 'OK' && resp.msgCode === 'MSWAPP:USERLISTSUCCESS') {
          this.$store.commit('stopLoading');
          this.showDeleteUserIcon = resp?.content?.showDeleteUserIcon;
          this.showOrgBasedIcon = resp?.content?.showOrgBasedIcon;
          this.orgBasedsuperAdminButtonText = resp?.content?.orgBasedsuperAdminButtonText || this.$t('accessMgmt.updateSuperAdmin').toString();
          this.$store.commit('AccessManagementStoreModule/setMaxSuperAdminCount', resp?.content?.maxSuperAdminCount || 1);
          if (resp?.content?.flexspendRole === 'YES') {
            this.showFlexSpend = true;
          } else {
            this.showFlexSpend = false;
          }
          this.flexspendAccessList = resp?.content?.flexspendAccessList
            ? resp?.content?.flexspendAccessList
            : [];
          this.flexspendAccessList =
            (this.flexspendAccessList.length > 0 &&
              this.flexspendAccessList.map((option: any) => {
                return {
                  id: option.choiceId,
                  value: option.choiceId,
                  label: option.choiceName,
                };
              })) ||
            [];
          this.userMgmtPermissionList = resp?.content?.userMgmtPermissionList
            ? resp?.content?.userMgmtPermissionList
            : [];
          this.userMgmtPermissionList =
            (this.userMgmtPermissionList.length > 0 &&
              this.userMgmtPermissionList.map((option: any) => {
                return {
                  id: option.choiceId,
                  value: option.choiceId,
                  label: option.choiceName,
                };
              })) ||
            [];
          this.showMswTypePermissionColumn =
            resp?.content?.hasOwnProperty('showOrgBasedIcon') &&
            resp?.content?.showOrgBasedIcon !== 'YES'
              ? true
              : false;
          this.showFlexspendAccessColumn = resp?.content?.flexspendRole === 'YES' ? true : false;
          let userListData = _.cloneDeep(resp?.content?.userList);
          this.userListData = userListData.map((ele: any, index: any) => {
            ele._key = index.toString();
            return ele;
          });
          resolve(true);
        } else {
          resolve(false);
          this.$store.commit('stopLoading');
          this.userListData = [];
        }
      });
    })
  }

  created() {
    this.loadFilterData();
    this.getUserList();

    this.buttons = [
      {
        key: 'cancel',
        name: this.$t('common.cancel')
        .toString(),
        isDefault: true,
      },
      {
        key: 'yes',
        name: this.$t('common.yes')
        .toString(),
      },
    ];
    this.options = {
      status: 'high',
      title: this.$t('products.confirmation')
      .toString(),
      message: '',
      buttons: this.buttons,
    };
  }

  updateIDP(user: any, mode: any) {
    confirmService
      .confirm({
        status: 'informational',
        title: this.$t('products.confirmation')
        .toString(), // tslint:disable-next-line
        message: `${this.$t('profile.userListCnfrmMsg1').toString()} ${mode === 'ON' ? 'on' : 'off'} ${this.$t('profile.userListCnfrmMsg2').toString()} ${
          user.emailAddress
        }`,
        buttons: [
          {
            key: 'cancel',
            name: this.$t('common.cancel')
            .toString(),
          },
          {
            key: 'ok',
            isDefault: true,
            name: this.$t('products.ok')
            .toString(),
          },
        ],
      })
      .then((key) => {
        if (key === 'ok') {
          const payload = {
            mode,
            usernames: [user.userName],
          };
          this.$store.commit('startLoading');
          this.$store
            .dispatch('AccessManagementStoreModule/updateIDP', payload)
            .then((resp: any) => {
              this.$store.commit('stopLoading');
              if (resp.operationStatus === 'OK') {
                const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
                this.$store.commit('enqueueMessage', message);
                this.getUserList();
              } else {
                const message: InfoState = { infoType: 'failed', infoMsg: resp.msgDesc };
                this.$store.commit('enqueueMessage', message);
              }
            })
            .catch(() => {
              this.$store.commit('stopLoading');
            });
        }
      });
  }

  updateTFA(user: any, mode: any) {
    confirmService
      .confirm({
        status: 'informational',
        title: this.$t('products.confirmation')
        .toString(), // tslint:disable-next-line
        message: `${this.$t('profile.userListCnfrmMsg1').toString()} ${mode === 'ON' ? 'on' : 'off'} ${this.$t('profile.userListCnfrmMsg3').toString()} ${
          user.emailAddress
        }`,
        buttons: [
          {
            key: 'cancel',
            name: this.$t('common.cancel')
            .toString(),
          },
          {
            key: 'ok',
            isDefault: true,
            name: this.$t('products.ok')
            .toString(),
          },
        ],
      })
      .then((key) => {
        if (key === 'ok') {
          const payload = {
            mode,
            usernames: [user.userName],
          };
          this.$store.commit('startLoading');
          this.$store
            .dispatch('AccessManagementStoreModule/updateTFA', payload)
            .then((resp: any) => {
              this.$store.commit('stopLoading');
              if (resp.operationStatus === 'OK') {
                const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
                this.$store.commit('enqueueMessage', message);
                this.getUserList();
              } else {
                const message: InfoState = { infoType: 'failed', infoMsg: resp.msgDesc };
                this.$store.commit('enqueueMessage', message);
              }
            })
            .catch(() => {
              this.$store.commit('stopLoading');
            });
        }
      });
  }

  openDeleteClicked(entry: any) {
    this.options.message = `${this.$t('profile.userListCnfrmMsg4').toString()} ${entry.fullName} ?`;
    confirmService.confirm(this.options).then((key) => {
      if (key === 'yes') {
        const req = {
          contactId: entry.contactId,
        };
        this.$store.commit('startLoading');
        this.$store.dispatch('SnbProfileStoreModule/removeUser', req).then((resp) => {
          this.$store.commit('stopLoading');
          if (resp.operationStatus === 'OK') {
            this.$store.commit('enqueueMessage', {
              infoType: 'success',
              infoMsg: resp.msgDesc,
            });
            this.getUserList();
          } else {
            this.$store.commit('enqueueMessage', {
              infoType: 'failed',
              infoMsg: resp.msgDesc,
            });
          }
        });
      }
    });
  }

  updateAdminStatus(entry: any) {
    const req = {
      partyId: entry.partyId,
    };
    this.$store.commit('startLoading');
    this.$store.dispatch('SnbProfileStoreModule/updateAdminRole', req).then((resp) => {
      this.$store.commit('stopLoading');
      if (resp.operationStatus === 'OK') {
        this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
        this.getUserList().then((res: any) => {
          res && this.applyFilters();
        });
        // this.reloadData();
      } else {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
      }
    });
  }

  getFloatActions(
    entry: TableEntry,
    index: number,
    scope: any = this,
  ): TableEntryFloatAction[] {
    let floatingActionsToShow: any = [];
    const floatingActions: any = [
      {
        icon: { name: 'carriers-industries', color: 'white' },
        action(entry: any) {
          scope.updateAdminStatus(entry);
        },
        tooltip: {
          content: entry.isAdmin === 'YES' ? this.$t('profile.removeAdmin')
          .toString() : this.$t('profile.markAsAdmin')
          .toString(),
        },
      },
      {
        icon: { name: 'trash', color: 'white' },
        action(entry: any) {
          scope.openDeleteClicked(entry);
        },
        tooltip: {
          content: this.$t('profile.deleteUser')
          .toString(),
        },
      },
      {
        icon: { name: entry.tfaStatus === 'YES' ? 'locked' : 'unlocked', color: 'white' },
        action(entry: any) {
          scope.updateTFA(entry, entry.tfaStatus === 'YES' ? 'OFF' : 'ON');
        },
        tooltip: {
          content: entry.tfaStatus === 'YES' ? 'TFA mode is Email' : 'TFA mode is off',
        },
      },
      {
        icon: { name: entry.idpStatus === 'YES' ? 'user' : 'user-lock', color: 'white' },
        action(entry: any) {
          scope.updateIDP(entry, entry.idpStatus === 'YES' ? 'OFF' : 'ON');
        },
        tooltip: {
          content:
            entry.idpStatus === 'YES'
              ? 'This user is an IDP enabled.'
              : 'This user is not an IDP enabled.',
        },
      },
    ];
    if (entry.showAdminImage === 'true') {
      floatingActionsToShow.push(floatingActions[0]);
    }
    if (this.showDeleteUserIcon) {
      floatingActionsToShow.push(floatingActions[1]);
    }
    if (entry.employee === 'YES' && entry.showTFAModeUserIcon === 'YES') {
      if (entry.tfaStatus === 'YES' || entry.tfaStatus === 'NO') {
        floatingActionsToShow.push(floatingActions[2]);
      }
    }
    if (entry.employee === 'YES' && entry.showIDPUserIcon === 'YES') {
      if (entry.idpStatus === 'YES' || entry.idpStatus === 'NO') {
        floatingActionsToShow.push(floatingActions[3]);
      }
    }
    floatingActionsToShow = new Set(floatingActionsToShow);
    return Array.from(floatingActionsToShow);
  }

  updateMswRole(partyId: string, choiceId: string) {
    const request = { partyid: partyId, choiceid: choiceId };
    this.$store
      .dispatch('SnbProfileStoreModule/updateMswRole', request)
      .then((resp: any) => {
        this.$store.commit('stopLoading');
        if (resp.operationStatus === 'OK') {
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
        }
        this.getUserList();
      });
  }

  actionColumnRenderer(h: CreateElement, data: { entry: TableEntry }) {
    return (
      <div>
        {
          data.entry.showAdminImage === 'true' &&
          <span style='margin-left: 15px'>
            <SwIcon
              name='carriers-industries'
              size={16}
              v-tooltip={{ content: data.entry.isAdmin === 'YES' ? this.$t('profile.removeAdmin')
                .toString() : this.$t('profile.markAsAdmin')
                .toString(), placement: 'top', compact: true }}
                nativeOn-click={() => this.updateAdminStatus(data.entry)}
            >
            </SwIcon>
          </span>
        }
        {
          (data.entry.deleteLink === 'true') &&
          <span style='margin-left: 15px'>
            <SwIcon
              name='trash'
              size={16}
              v-tooltip={{ content: (this.$t('profile.deleteUser')
                .toString()), placement: 'top', compact: true }}
              nativeOn-click={() => this.openDeleteClicked(data.entry)}
            >
            </SwIcon>
          </span>
        }
        {
          (data.entry.showTFAModeUserIcon === 'YES') &&
          (data.entry.tfaStatus === 'YES' || data.entry.tfaStatus === 'NO' || data.entry.tfaStatus === 'APP') &&
          <span style='margin-left: 15px'>
            <SwIcon
              name={data.entry.tfaStatus === 'YES' || data.entry.tfaStatus === 'APP' ? 'locked' : 'unlocked'}
              size={16}
              v-tooltip={{ content: data.entry.tfaStatus === 'YES' ? (this.$t('accessMgmt.tfaEmail')
                .toString()) : data.entry.tfaStatus === 'APP' ? (this.$t('accessMgmt.tfaApp')
                .toString()) : (this.$t('accessMgmt.tfaOff')
                .toString()), placement: 'top', compact: true }}
              nativeOn-click={() => data.entry.tfaStatus !== 'APP' && this.updateTFA(data.entry, data.entry.tfaStatus === 'YES' ? 'OFF' : 'ON')}
            >
            </SwIcon>
          </span>
        }

        {
          (data.entry.showViewUserAPIKey === 'YES') &&
          <span style='margin-left: 15px'>
            <span class="action_key_icon" onClick={() => this.viewOrRevokeOrGrantApi(data.entry)}  v-tooltip={{ content: (this.$t('accessMgmt.viewKeyFromTable')
              .toString()), placement: 'top', compact: true }}></span>
          </span>
        }
        {
          (data.entry.showIDPUserIcon === 'YES') &&
          (data.entry.idpStatus === 'YES' || data.entry.idpStatus === 'NO') &&
          <span style='margin-left: 15px'>
            <SwIcon
              name={data.entry.idpStatus === 'YES' ? 'user' : 'user-lock'}
              size={16}
              v-tooltip={{content: data.entry.idpStatus === 'YES' ? 'This user is an IDP enabled.' : 'This user is not an IDP enabled.', placement: 'top', compact: true }}
              nativeOn-click={() => this.updateIDP(data.entry, data.entry.idpStatus === 'YES' ? 'OFF' : 'ON')}
            >
            </SwIcon>
          </span>
        }
      </div>
    ) as VNode;
  }

  accessColumnRenderer(h: CreateElement, data: { entry: TableEntry }) {
    const selectedChoiceId = data.entry.userPermissionId || this.getUserMgmtPermissionOptions[0]?.id;
    const isDisableSelect = data.entry.isUserPermissionDropdownDisabled && data.entry.showUserPermissionDropdown;
    const labelText = data.entry.userPermissionText;
    return (
      data.entry.showUserPermissionLabel ?
      <div>
        { labelText }
      </div> :
      <div>
        <SwSelect
          name='select'
          style='width: 150px; margin: 5px 0;'
          props-options={this.getUserMgmtPermissionOptions}
          props-value={selectedChoiceId}
          props-disabled={isDisableSelect}
          on-change={(value: string) => {
            data.entry.userPermissionId = value;
            const partyId = data.entry.partyId;
            this.updateMswRole(partyId, value);
          }}
        ></SwSelect>
      </div>
    ) as VNode;
  }

  openAPIdocumentation() {
    const apiUrl: any = envCongif.api_url;
    const url = new URL(apiUrl);
    const swaggerUrl = `${url.protocol}//${url.hostname}`;
    console.warn('printing swagger url', swaggerUrl);
    window.open(`${swaggerUrl}/mssp.html`, '_blank');
  }

  viewOrRevokeOrGrantApi(data: any, mode: string = "GET") {
    this.showHyperLink = true;
    this.$store.commit('startLoading');
    let reqBody: any = {
      mode,
      sourceName: "MSSP",
      username: data.userName,
    };
    this.$store
      .dispatch('SnbProfileStoreModule/viewOrRevokeOrGrant', reqBody)
      .then((resp: any) => {
        this.$store.commit('stopLoading');
        if (resp.operationStatus === 'OK') {
          this.userDetails = data;
          console.warn(data);
          if (mode === 'GET') {
            this.dataToDisplay = resp.content;
            this.dataToDisplay.email = data.emailAddress;
            if (data.associatedUserGroups !== undefined || data.associatedUserGroups !== '') this.dataToDisplay.userGrp = data.associatedUserGroups;
            this.showDetails = true;
            ((resp.content.status === 'ACTIVE'  || resp.content.status === 'EXPIRED') && data.userName === JSON.parse((localStorage as any).getItem('currentUser')).userId) ?
            this.showDelete = true : this.showDelete = false;
            (resp.content.status === 'ACTIVE' && data.userName !== JSON.parse((localStorage as any).getItem('currentUser')).userId) ?
            this.showRevoke = true : this.showRevoke = false;
            (resp.content.status === 'REVOKED' && data.userName !== JSON.parse((localStorage as any).getItem('currentUser')).userId) ?
            this.showGrant = true : this.showGrant = false;
            this.openApiKeyDetails = true;
          } else {
            this.openApiKeyDetails = false;
            this.getUserList();
          }
          if (resp.msgCode === 'MSWAPP:APIKEYDGRANTSUCCESS' || resp.msgCode === 'MSWAPP:APIKEYREVOKESUCCESS') {
            const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
            this.$store.commit('enqueueMessage', message);
          }
        } else {
          const message: InfoState = { infoType: 'failed', infoMsg: resp.msgDesc };
          this.$store.commit('enqueueMessage', message);
        }
      });
  }

  getStartDate() {
    const today = new Date();
    const dd = String(today.getDate())
    .padStart(2, '0');
    const mm = String(today.getMonth() + 1)
              .padStart(2, '0'); // January is 0!
    const yyyy = today.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  }

  getEndDate() {
    let oneYearFromNow = new Date();
    oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);
    const dd2 = String(oneYearFromNow.getDate())
    .padStart(2, '0');
    const mm2 = String(oneYearFromNow.getMonth() + 1)
              .padStart(2, '0'); // January is 0!
    const yyyy2 = oneYearFromNow.getFullYear();
    return `${dd2}/${mm2}/${yyyy2}`;
  }

  showFormToGenerateKey() {
    Object.keys(this.apiKey).forEach((item: any) => {
      this.apiKey[item] = '';
    })
    this.apiKey.userType = 'Employee';
    this.apiKey.userEmail = JSON.parse((localStorage as any).getItem('currentUser')).email;
    this.apiKey.expDate = this.getEndDate();
    this.showGeneratedKey = false;
    this.showDetails = false;
    this.showGrant = false;
    this.showHyperLink = false;
    this.showDelete = false;
    this.showRevoke = false;
    this.openApiKeyDetails = true;
  }

  showKeyForLoggedInUser() {
    const details = {
      userName: JSON.parse((localStorage as any).getItem('currentUser')).userId,
      emailAddress: JSON.parse((localStorage as any).getItem('currentUser')).email,
    };
    this.viewOrRevokeOrGrantApi(details);
  }

  revokeConfirmation(payload: any) {
    confirmService.confirm({
      status: 'informational',
      title: String(this.$t('products.confirmation')),
      message: String(this.$t('accessMgmt.removeKey')),
      buttons: [{ key: 'cancel', name: String(this.$t('common.cancel')) }, { key: 'ok', name: String(this.$t('products.ok')) }],
    })
    .then((key) => {
      if (key === 'ok') this.viewOrRevokeOrGrantApi(payload, 'REVOKE');
    });
  }

  grantConfirmation(payload: any) {
    confirmService.confirm({
      status: 'informational',
      title: String(this.$t('products.confirmation')),
      message: String(this.$t('accessMgmt.keyBack')),
      buttons: [{ key: 'cancel', name: String(this.$t('common.cancel')) }, { key: 'ok', name: String(this.$t('products.ok')) }],
    })
    .then((key) => {
      if (key === 'ok') this.viewOrRevokeOrGrantApi(payload, 'GRANT');
    });
  }

  deleteConfirmation() {
    confirmService.confirm({
      status: 'informational',
      title: String(this.$t('products.confirmation')),
      message: String(this.$t('accessMgmt.deleteKey')),
      buttons: [{ key: 'cancel', name: String(this.$t('common.cancel')) }, { key: 'ok', name: String(this.$t('products.ok')) }],
    })
    .then((key) => {
      if (key === 'ok') this.deleteApiKey();
    });
  }

  generateApiKeyOrClose(str: any) {
    if (str === 'Confirm') {
      if (this.apiKey.desc.length < 100) {
        const formattedDate = this.apiKey.expDate.split('/');
        const reqBody = {
          mode: "INSERT",
          sourceName: "MSSP",
          description: this.apiKey.desc,
          ipAddress: this.apiKey.ip,
          expDate: `${formattedDate[1]}/${formattedDate[0]}/${formattedDate[2]}`,
        }
        this.$store
          .dispatch('SnbProfileStoreModule/viewOrRevokeOrGrant', reqBody)
          .then((resp: any) => {
            this.$store.commit('stopLoading');
            if (resp.operationStatus === 'OK' && resp.msgCode === 'MSWAPP:APIKEYCREATESUCCESS') {
              this.generatedApiKey = resp.content.apiKey;
              this.generatedMsg = resp.msgDesc;
              this.showGeneratedKey = true;
              this.showHyperLink = true;
            } else {
              const message: InfoState = { infoType: 'failed', infoMsg: resp.msgDesc };
              this.$store.commit('enqueueMessage', message);
            }
          });
      } else {
        const message: InfoState = { infoType: 'failed', infoMsg: 'Description character length should be less than 100' };
        this.$store.commit('enqueueMessage', message);
      }
    } else {
      this.openApiKeyDetails = false;
      this.showGeneratedKey = false;
      this.showAPIkey = false;
      this.getUserList();
    }
  }

  closeAPImodal() {
    this.openApiKeyDetails = false;
    if (this.showGeneratedKey){
      this.getUserList();
      this.showGeneratedKey = false;
    }
  }

  copyToClipBoard() {
    window.navigator.clipboard.writeText(this.generatedApiKey);
    this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: 'Copied to clipboard!' });
  }

  deleteApiKey() {
    const reqBody = {
      mode: "DELETE",
      sourceName: "MSSP",
    }
    this.$store
      .dispatch('SnbProfileStoreModule/viewOrRevokeOrGrant', reqBody)
      .then((resp: any) => {
        this.$store.commit('stopLoading');
        if (resp.operationStatus === 'OK' && resp.msgCode === 'MSWAPP:APIKEYDELETESUCCESS') {
          this.openApiKeyDetails = false;
          const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
          this.$store.commit('enqueueMessage', message);
          this.getUserList();
        } else {
          const message: InfoState = { infoType: 'failed', infoMsg: resp.msgDesc };
          this.$store.commit('enqueueMessage', message);
        }
      });
  }

  updateFlexspendAccess(partyId: string, choiceId: string) {
    const request = { partyid: partyId, choiceid: choiceId };
    this.$store
      .dispatch('SnbProfileStoreModule/updateFlexspendAccess', request)
      .then((resp: any) => {
        this.$store.commit('stopLoading');
        if (resp.operationStatus === 'OK') {
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
        }
        this.getUserList();
      });
  }

  flexspendAccessColumnRenderer(h: CreateElement, data: { entry: TableEntry }) {
    const selectedChoiceId = data.entry.choiceId
      ? data.entry.choiceId
      : this.getFlexspendAccessOptions[0].id;
    const isDisableSelect =
      data.entry.enableFlexspendAccess && data.entry.enableFlexspendAccess === 'NO'
        ? true
        : false;
    return (
      <div>
        <SwSelect
          name='select'
          props-options={this.getFlexspendAccessOptions}
          props-value={selectedChoiceId}
          props-disabled={isDisableSelect}
          on-change={(value: string) => {
            const partyId = data.entry.partyId;
            this.updateFlexspendAccess(partyId, value);
          }}
        ></SwSelect>
      </div>
    ) as VNode;
  }

  cssaColumnRenderer(h: CreateElement, data: { entry: TableEntry }) {
    return (data.entry.cssaNum !== '' ? (
      <div>
        <span>menu</span>
      </div>
    ) : (
      <div style='display:flex;'>
        <span style='margin-right:20px;'>--</span>
      </div>
    )) as VNode;
  }

  employeeColumnRenderer(h: CreateElement, data: { entry: TableEntry }) {
    return (data.entry.employee === 'YES' ? (
      <div>
        <SwIcon name='checkmark' size='small'></SwIcon>
      </div>
    ) : null) as VNode;
  }

  adminColumnRenderer(h: CreateElement, data: { entry: TableEntry }) {
    return (data.entry.isAdmin === 'YES' ? (
      <div>
        <SwIcon name='checkmark' size='small'></SwIcon>
      </div>
    ) : null) as VNode;
  }

  get userListDataConfig(): TableColumnConfig[] {
    const config: TableColumnConfig[] = [
      {
        key: 'index',
        type: 'index',
      },
      {
        key: 'logon',
        dataKey: 'logon',
        title: this.$t('orderHistory.status')
        .toString(),
        sorter: true,
        width: 100,
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          {
            return (
              <div
                style={{ display: 'flex', flex: '1', alignItems: 'center' }}
                on-mouseover={() => {
                  this.filterColumnKey = data.entry._key;
                  this.filterColumnValue = data.entry.logon;
                }}
                on-mouseleave={() => (this.filterColumnKey = '')}
              >
                {data.entry.logon}
                {this.filterColumnKey === data.entry._key &&
                  this.filterColumnValue === data.entry.logon && (
                    <SwIcon
                      name='filter'
                      size={12}
                      style={{ marginLeft: '5px' }}
                      v-tooltip={{ content: 'Add Filter', compact: true, placement: 'bottom' }}
                      nativeOn-click={() => {
                        this.expandVisible = true;
                        this.statusFilter = data.entry.logon;
                        this.applyFilters();
                      }}
                    ></SwIcon>
                  )}
              </div>
            ) as VNode;
          }
        },
      },
      {
        key: 'fullName',
        dataKey: 'fullName',
        title: this.$t('products.name')
        .toString(),
        sorter: true,
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          {
            return (
              <div
                style={{ display: 'flex', flex: '1', alignItems: 'center' }}
                on-mouseover={() => {
                  this.filterColumnKey = data.entry._key;
                  this.filterColumnValue = data.entry.fullName;
                }}
                on-mouseleave={() => (this.filterColumnKey = '')}
              >
                {data.entry.fullName}

                {this.filterColumnKey === data.entry._key &&
                  this.filterColumnValue === data.entry.fullName && (
                    <SwIcon
                      name='filter'
                      size={12}
                      style={{ marginLeft: '5px' }}
                      v-tooltip={{ content: 'Add Filter', compact: true, placement: 'bottom' }}
                      nativeOn-click={() => {
                        this.expandVisible = true;
                        this.nameFilter = data.entry.fullName;
                        this.applyFilters();
                      }}
                    ></SwIcon>
                  )}
              </div>
            ) as VNode;
          }
        },
      },
      {
        key: 'emailAddress',
        dataKey: 'emailAddress',
        title: this.$t('profile.email')
        .toString(),
        sorter: true,
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          {
            return (
              <div
                style={{ display: 'flex', flex: '1', alignItems: 'center' }}
                on-mouseover={() => {
                  this.filterColumnKey = data.entry._key;
                  this.filterColumnValue = data.entry.emailAddress;
                }}
                on-mouseleave={() => (this.filterColumnKey = '')}
              >
                {data.entry.emailAddress}

                {this.filterColumnKey === data.entry._key &&
                  this.filterColumnValue === data.entry.emailAddress && (
                    <SwIcon
                      name='filter'
                      size={12}
                      style={{ marginLeft: '5px' }}
                      v-tooltip={{ content: 'Add Filter', compact: true, placement: 'bottom' }}
                      nativeOn-click={() => {
                        this.expandVisible = true;
                        this.emailFilter = data.entry.emailAddress;
                        this.applyFilters();
                      }}
                    ></SwIcon>
                  )}
              </div>
            ) as VNode;
          }
        },
      },
      {
        key: 'associatedUserGroups',
        dataKey: 'associatedUserGroups',
        title: this.$t('groups.editUGroupName')
        .toString(),
        sorter: true,
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          {
            return (
              <div
                style={{ display: 'flex', flex: '1', alignItems: 'center' }}
                on-mouseover={() => {
                  this.filterColumnKey = data.entry._key;
                  this.filterColumnValue = data.entry.associatedUserGroups;
                }}
                on-mouseleave={() => (this.filterColumnKey = '')}
              >
                {data.entry.associatedUserGroups}

                {this.filterColumnKey === data.entry._key &&
                  this.filterColumnValue === data.entry.associatedUserGroups && (
                    <SwIcon
                      name='filter'
                      size={12}
                      style={{ marginLeft: '5px' }}
                      v-tooltip={
                        {
                          content: this.$t('common.addFilter')
                          .toString(),
                          compact: true,
                          placement: 'bottom',
                        }
                      }
                      nativeOn-click={() => {
                        this.expandVisible = true;
                        this.userGroupFilter = data.entry.associatedUserGroups;
                        this.applyFilters();
                      }}
                    ></SwIcon>
                  )}
              </div>
            ) as VNode;
          }
        },
      },
      {
        key: 'cssaNum',
        dataKey: '',
        title: this.$t('home.cssa')
        .toString(),
        width: 100,
        render: (h: CreateElement, data: { entry: TableEntry }): VNode =>
          this.cssaColumnRenderer(h, data),
      },
    ];
    // if(this.showMswTypePermissionColumn) {
    const typeColumn = {
      key: 'userType',
      dataKey: 'userType',
      title: this.$t('accessMgmt.type')
      .toString(),
      width: 100,
    };
    const permissionColumn = {
      key: 'permissionRenderer',
      dataKey: '',
      title: this.$t('accessMgmt.usrMngPermission').toString(),
      width: 170,
      tooltip: this.permissionTooltipValue,
      render: (h: CreateElement, data: { entry: TableEntry }): VNode =>
        this.accessColumnRenderer(h, data),
    };
    config.push(typeColumn);
    config.push(permissionColumn);
    // }
    if (this.showFlexspendAccessColumn) {
      const flexspendAccessColumn = {
        key: 'flexspend',
        dataKey: '',
        title: this.$t('profile.flexspendaccess')
        .toString(),
        scalable: true,
        render: (h: CreateElement, data: { entry: TableEntry }): VNode =>
          this.flexspendAccessColumnRenderer(h, data),
      };
      config.push(flexspendAccessColumn);
    }
    const actionColumn = {
      key: 'action',
      dataKey: '',
      title: this.$t('common.action').toString(),
      width: 150,
      render: (h: CreateElement, data: { entry: TableEntry }): VNode =>
        this.actionColumnRenderer(h, data),
    };
    config.push(actionColumn);
    return config;
  }

  get permissionTooltipValue(): TooltipDirValues {
    return {
      enabled: true,
      placement: 'bottom',
      compact: true,
      content: String(this.$t('accessMgmt.usrMngPermission')),
      includePopperForHover: true,
    };
  }

  reloadData() {
    this.filterApplied = false;
    this.expandVisible = false;
    this.isExpandSearchFilter = false;
    this.getUserList();
  }

  addNewUser() {
    this.displayAddNewUser = true;
  }

  openAddOrUpdateSuperAdminModal() {
    this.$store.dispatch('AccessManagementStoreModule/getAdminList')
    .then((res: any) => {
      this.$store.commit('stopLoading');
      if (res?.operationStatus === 'OK') {
        this.$store.commit('AccessManagementStoreModule/setAdminList', res?.adminList || []);
        this.addOrUpdateSuperAdminModal = true;
      } else {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res?.msgDesc });
      }
    })
    .catch(() => {
      this.$store.commit('stopLoading');
    });
  }

  closeAddOrUpdateSuperAdminModal(loadPage: boolean) {
    this.addOrUpdateSuperAdminModal = false;
    if (loadPage) {
      // this.getUserList();
      this.reloadData();
    }
  }
}
